import { useDropzone } from "react-dropzone";
import Button from "../../../../component/button";
import React from "react";

const FileUploader = ({ t, importProductSpecs, onFilesError }) => {
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: { "application/json": [".json"] },
    maxSize: 10 * 1024 * 1024, // 10 MB
    multiple: false,
    onDropAccepted: (acceptedFiles) => {
      if (acceptedFiles && acceptedFiles.length > 0) {
        importProductSpecs(acceptedFiles);
      }
    },
    onDropRejected: (fileRejections) => {
      if (onFilesError) onFilesError(fileRejections);
    },
  });

  return (
    <div
      {...getRootProps()}
      className="files-dropzone"
      style={{ display: "inline-block" }}
    >
      <input {...getInputProps()} />
      <Button
        className="buttonSecondary"
        style={{ marginLeft: ".5rem", marginRight: ".5rem" }}
      >
        {isDragActive ? t("DROP_FILE_HERE") : t("IMPORT")}
      </Button>
    </div>
  );
};

export default FileUploader;
